/*******************************************************************
 * Generated by RxDjango on 2026-07-16 12:17 (UTC)                 *
 *                                                                 *
 * Based on all ContextChannel subclasses in nested_model.channels *
 *                                                                 *
 *                      DO NOT EDIT THIS FILE                      *
 *                                                                 *
 * To rebuild it, run:                                             *
 *                                                                 *
 *     ./manage.py makefrontend [nested_model]                     *
 *                                                                 *
 *******************************************************************/

import { ContextChannel } from '@rxdjango/react';
import type { User } from './nested_model.models';

const SOCKET_URL = (process.env.REACT_APP_RX_WEBSOCKET_URL ?? 'ws://localhost:8000') as string;

export class NestedModelChannel extends ContextChannel {

  protected endpoint: string = "/ws/nested_model/";
  protected baseURL: string = SOCKET_URL;

  user: User | null = null;

  protected _modelFields: Record<string, {
      anchor: string;
      model: Record<string, Record<string, string>>;
      many?: boolean;
    }> = {
      "user": {
        anchor: "nested_model.serializers.UserSerializer",
        model: {
          "nested_model.serializers.UserSerializer": { "company": "nested_model.serializers.CompanySerializer" },
          "nested_model.serializers.CompanySerializer": {  },
        },
      },
    };

  authorize = async (password: string) => {
    return await this.rx.callAction('authorize', [password]);
  };
}
